import { appConfiguration } from '../../utils/app-starter';

export const setUserInformation = (senderEmail, senderName) => {
  try {
    sessionStorage.setItem('mailInformation', JSON.stringify({ senderEmail, senderName }));
  } catch (error) {
  }
}

export const getUserInformation = () => {
  try {
    if (appConfiguration.seamlessSession) {
      return { senderEmail: appConfiguration.seamlessSession.email, senderName: appConfiguration.seamlessSession.name }
    }
    const mailInformationStr = sessionStorage.getItem('mailInformation');
    return mailInformationStr ? JSON.parse(mailInformationStr) : { senderEmail: '', senderName: '' };
  }
  catch (error) {
    return { senderEmail: '', senderName: '' };
  }
}
